module.exports = __webpack_public_path__ + "img/risk-level.bfc6445a.png";